import { Chat } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import ChatInterface from '../components/ChatInterface';

import useExpertReview from 'hooks/useExpertReview';
import { RootState } from 'redux/store';

const ExpertReviewPage = () => {
    const params = useParams();
    const selectedApplicationId = Number(params.id);
    const { id: userId } = useSelector((state: RootState) => state.user.entity);
    const { applications } = useSelector((state: RootState) => state.applications);

    const {
        isLoading,
        messages,
        chatGroupId,
        users,
        hasAccess,
        sendingMessage,
        handleSendMessage,
        getApplicantChatObj,
        resetChat,
    } = useExpertReview();

    const [checked] = useState(false);
    const selectedApplication = applications.find((app) => app.id === selectedApplicationId);

    useEffect(() => {
        if (!userId) return;

        if (!selectedApplicationId || !selectedApplication) {
            resetChat();
            return;
        }

        const isBackOffice = Boolean(
            selectedApplication.backoffice_name && selectedApplication.backoffice_id && checked
        );
        getApplicantChatObj(selectedApplicationId, isBackOffice);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedApplicationId, selectedApplication, checked, userId]);

    return (
        <Box
            sx={{
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'background.default',
                overflow: 'hidden',
            }}
        >
            {!selectedApplicationId ? (
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 3,
                    }}
                >
                    <Chat sx={{ fontSize: 80, color: 'text.secondary', mb: 3 }} />
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                        Expert Review Chat
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 4, textAlign: 'center', maxWidth: 500 }}
                    >
                        Select an application below to start chatting with immigration experts
                    </Typography>
                </Box>
            ) : (
                <ChatInterface
                    messages={messages}
                    chatGroupId={parseInt(chatGroupId) || 0}
                    users={users}
                    onSendMessage={handleSendMessage}
                    isSending={sendingMessage}
                    isLoading={isLoading}
                    hasAccess={hasAccess}
                />
            )}
        </Box>
    );
};

export default ExpertReviewPage;
